import { Button, Checkbox, CheckboxChangeEvent, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import Table from "../../../../../core/common/dataTable/index";

import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import { Toast } from "react-bootstrap";
import { CloseCircleOutlined } from "@ant-design/icons";

type Agent = {
  id: number;
  name: string;
};

// interface ErrorMessages {
//   name?: string[];
// }

const BranchAssignment = () => {
  const { Option } = Select;
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [data, setData] = useState<any[]>([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem("SEDBranchAssignment_filters");
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
          branch: "",
          building_category: "",
          sed_agents: null,
        };
  });
  useEffect(() => {
    localStorage.setItem(
      "SEDBranchAssignment_filters",
      JSON.stringify(filters),
    );
  }, [filters]);
  const [appliedFilters, setAppliedFilters] = useState(filters);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [unAsignshowCard, setUnAsignShowCard] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<number | null>(null);
  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  // const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if (!showSolidDangerToast && !showSolidSuccessToast) return;

    const timer = setTimeout(() => {
      setShowSolidDangerToast(false);
      setshowSolidSuccessToast(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [showSolidDangerToast, showSolidSuccessToast]);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  const FILTERS = [
    { label: "SCTS", value: "1" },
    { label: "ETS", value: "2" },
  ];

  useEffect(() => {
    if (
      !checkPermission(
        "view_branchassignmentforsedteam",
        "branchassignmentforsedteam",
      )
    ) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(currentPage, pageSize, searchText);
      fetchAgentsData();
    }
  }, [userPermissions, appliedFilters]);

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
  ) => {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      search: searchText || "",
      branch: appliedFilters.branch || "",
      building_category: appliedFilters.building_category || "",
    });
    if (appliedFilters.sed_agents) {
      queryParams.append("sed_agents", appliedFilters.sed_agents);
    }
    const response = await fetch(
      `${webApi}/sed/sed_branch_assignment_for_sed/?${queryParams.toString()}`,
      options,
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  // Assign Branch
  const fetchAgentsData = async () => {
    try {
      const res = await fetch(
        `${webApi}/sed/team_members_dropdown_for_branch_assignment/`,
        options,
      );
      const data = await res.json();
      setAgentsDropdown(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText),
      ]);
      setData(groupsData.results);
      setTotalCount(groupsData.total_count);
      setCurrentPage(groupsData.current_page_number);
      // setToastMessage(groupsData.message || "submitted successfully!");
      // setshowSolidSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    setCurrentPage(1);
    fetchData(1, pageSize, value);
  };

  // const handleSelect = (
  //   branch_id: any,
  //   selectedRowKeys: number[],
  //   setSelectedRowKeys: React.Dispatch<React.SetStateAction<number[]>>,
  // ) => {
  //   const selectedIds = [...selectedRowKeys];
  //   const index = selectedIds.indexOf(branch_id);
  //   if (index >= 0) {
  //     selectedIds.splice(index, 1);
  //   } else {
  //     selectedIds.push(branch_id);
  //   }
  //   setSelectedRowKeys(selectedIds);
  // };

  const handleSelect = (branchId: number) => {
  setSelectedRowKeys((prev) =>
    prev.includes(branchId)
      ? prev.filter((id) => id !== branchId)
      : [...prev, branchId]
  );
};

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { branch: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<number[]>>,
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.branch);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const handleSelectChange = (value: number) => {
    setSelectedAgent(value);
  };

  // handle Agent Assignment
  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${webApi}/sed/assign_sed_agents/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({
          branch_ids: selectedRowKeys,
          sed_agent_ids: [selectedAgent],
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        setToastMessage(data.sed_agent_ids[0]);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign agent");
      }

      setToastMessage(data.detail);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setAsignShowCard(false);
      fetchData(currentPage, pageSize, searchText);
    } catch (error) {
      console.error("Failed to assign SED agent", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Un Assignment  agent
  const handleUNAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${webApi}/sed/unassign_sed_agents/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({
          branch_ids: selectedRowKeys,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        setToastMessage(data.message);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign SED agent");
      }
      setToastMessage(data.detail);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setUnAsignShowCard(false);
      fetchData(currentPage, pageSize, searchText);
    } catch (error) {
      console.error("Failed to unassign SED agent", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleApplyClick = () => {
    setAppliedFilters(filters);
    setCurrentPage(1);
    setShowFilter(false);
  };

  const handleResetClick = () => {
    const emptyFilters = {
      branch: "",
      building_category: "",
      sed_agents: null,
    };
    setFilters(emptyFilters);
    setAppliedFilters(emptyFilters);
    setCurrentPage(1);
    setShowFilter(false);
  };

  //Reusable function to display applied filters
  const renderFilterTag = (
    value: string | null,
    filterKey: keyof typeof appliedFilters,
  ) => {
    if (!value) return null;

    return (
      <span
        style={{
          marginLeft: 8,
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <span style={{ color: "#1890ff", marginRight: 4 }}>({value})</span>

        <CloseCircleOutlined
          onClick={() => {
            const updatedFilters = {
              ...filters,
              [filterKey]: "",
            };

            setFilters(updatedFilters);
            setAppliedFilters(updatedFilters);
          }}
          style={{ color: "red", cursor: "pointer" }}
        />
      </span>
    );
  };

  const columns = [
    // Add action column only if permission exists
    ...(checkPermission(
      "change_branchassignmentforsedteam",
      "branchassignmentforsedteam",
    )
      ? [
          {
            title: "Action",
            dataIndex: "branch",
            key: "action",
            render: (_text: any, record: { branch: any }) => (
              <input
                type="checkbox"
                checked={selectedRowKeys.includes(record.branch)}
                onChange={() =>
                  handleSelect(
                    record.branch,
                    // selectedRowKeys,
                    // setSelectedRowKeys,
                  )
                }
              />
            ),
          },
        ]
      : []),

    {
      title: (
        <span>
          Branch category
          {renderFilterTag(
            FILTERS.find(
              (x) =>
                String(x.value) === String(appliedFilters.building_category),
            )?.label || "",
            "building_category",
          )}
        </span>
      ),
      dataIndex: "building_category",
    },
    {
      title: (
        <span>
          Branch Name
          {renderFilterTag(appliedFilters.branch, "branch")}
        </span>
      ),
      dataIndex: "branch_name",
    },
    {
      title: (
        <span>
          SED Agents
          {renderFilterTag(
            agentsDropdown.find(
              (x) => String(x.id) === String(appliedFilters.sed_agents),
            )?.name || null,
            "sed_agents",
          )}
        </span>
      ),
      dataIndex: "sed_agents",
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">SED Branch Assignment</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Branches
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <div className="mb-2">
                {checkPermission("add", "summercamppriority") && (
                  <Link to={routes.SummerCampAddPriorities} className="btn btn-primary">
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Priority
                  </Link>
                )}
              </div> */}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Branches List</h4>
              <div className="d-flex align-items-center flex-wrap"></div>
              <div className="d-flex align-items-center flex-wrap ms-auto gap-2">
                {checkPermission(
                  "change_branchassignmentforsedteam",
                  "branchassignmentforsedteam",
                ) && (
                  <Checkbox
                    indeterminate={
                      selectedRowKeys.length > 0 &&
                      selectedRowKeys.length < data.length
                    }
                    checked={selectedRowKeys.length === data.length}
                    onChange={(e) =>
                      handleSelectAll(e, data, setSelectedRowKeys)
                    }
                  >
                    Select All
                  </Checkbox>
                )}

                {checkPermission(
                  "change_branchassignmentforsedteam",
                  "branchassignmentforsedteam",
                ) && (
                  <button
                    className="btn btn-primary"
                    onClick={() => setAsignShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Assign Branch
                  </button>
                )}

                {checkPermission(
                  "change_branchassignmentforsedteam",
                  "branchassignmentforsedteam",
                ) && (
                  <button
                    className="btn btn-primary"
                    onClick={() => setUnAsignShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Unassign Branch
                  </button>
                )}

                <div className="mb-1">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    Filter
                  </button>
                  {showFilter && (
                    <div
                      className="card mt-3 shadow-sm"
                      style={{
                        width: "500px",
                        position: "absolute",
                        right: 0,
                        zIndex: 1000,
                        borderRadius: "12px",
                      }}
                    >
                      <form>
                        {/* Header */}
                        <div className="d-flex align-items-center border-bottom p-3">
                          <h4 className="mb-0 me-auto">Filter</h4>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowFilter(false)}
                          />
                        </div>

                        {/* Body */}
                        <div className="p-3">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Building Category
                                </label>
                                <Select
                                  showSearch
                                  allowClear
                                  placeholder="Select Build Category"
                                  value={filters.building_category || ""}
                                  onChange={(value) =>
                                    setFilters({
                                      ...filters,
                                      building_category: value || "",
                                    })
                                  }
                                  style={{ width: "100%" }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.children as unknown as string)
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {FILTERS.map((teamLead) => (
                                    <Option
                                      key={teamLead.value}
                                      value={teamLead.value}
                                    >
                                      {teamLead.label}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Branch Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={filters.branch}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      branch: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">SED Agents</label>
                                <Select
                                  showSearch
                                  allowClear
                                  placeholder="Select SED Agent"
                                  value={filters.sed_agents}
                                  onChange={(value) =>
                                    setFilters({
                                      ...filters,
                                      sed_agents: value,
                                    })
                                  }
                                  style={{ width: "100%" }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.children as unknown as string)
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {agentsDropdown.map((teamLead) => (
                                    <Option
                                      key={teamLead.id}
                                      value={teamLead.id}
                                    >
                                      {teamLead.name}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <div className="p-3 border-top d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light me-3"
                            onClick={handleResetClick}
                          >
                            Reset
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApplyClick}
                          >
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={data}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "20", "100"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
          <>
            {unAsignshowCard && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  zIndex: 1049,
                }}
              >
                <div
                  className="card"
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "20%",
                    boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                    borderRadius: "10px",
                    zIndex: 1050,
                    backgroundColor: "#f9f9f9",
                    padding: "20px",
                  }}
                >
                  <div className="popup-overlay modal-body">
                    <div className="popup-container">
                      <div className="popup-content text-center">
                        <span className="delete-icon">
                          <i className="ti ti-trash-x" />
                        </span>
                        <h4>Confirm UnAssign</h4>
                        <p>Do you Want to Unassign the Branches.</p>
                        <div className="d-flex justify-content-center gap-3">
                          <button
                            className="btn btn-light"
                            onClick={() => setUnAsignShowCard(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={handleUNAgentAssignment}
                          >
                            Yes, UnAssign
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* /Delete Modal */}
          </>
        </div>
      </div>

      {AsignshowCard && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1049,
            }}
          />
          <div
            className="card"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "20%",
              boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
              borderRadius: "10px",
              zIndex: 1050,
              backgroundColor: "#f9f9f9",
              padding: "20px",
            }}
          >
            <form onSubmit={handleAgentAssignment}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{
                          paddingBottom: "10px",
                          fontWeight: "bold",
                          color: "#555",
                        }}
                      >
                        Select Team Agent 
                      </label>
                      {isLoading ? (
                        <Spin />
                      ) : (
                        <Select
                          // mode="multiple"
                          value={selectedAgent}
                          onChange={handleSelectChange}
                          style={{
                            width: "100%",
                          }}
                          showSearch
                          filterOption={(input, option) => {
                            if (!option || !option.children) return false; // Check if option or option.children is undefined
                            const label = option.children as unknown as string; // Ensure that option.children is treated as a string
                            return label
                              .toLowerCase()
                              .includes(input.toLowerCase());
                          }}
                        >
                          {agentsDropdown.map((agent) => (
                            <Option key={agent.id} value={agent.id}>
                              {agent.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-light me-2"
                  onClick={() => setAsignShowCard(false)}
                >
                  Cancel
                </Button>
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={isLoading}
                >
                  Save Changes
                </button>
              </div>
            </form>

            {/* /Row */}
            <Toast
              show={showSolidDangerToast}
              onClose={handleSolidDangerToastClose}
              id="solidDangerToast"
              className="colored-toast bg-danger text-fixed-white"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              style={{
                position: "fixed",
                top: "20px",
                right: "20px",
                zIndex: 1050,
              }}
            >
              <Toast.Body>{toastMessage}</Toast.Body>
            </Toast>
            <Toast
              show={showSolidSuccessToast}
              onClose={handleSolidSuccessToastClose}
              id="solidSuccessToast"
              className="colored-toast bg-success text-fixed-white"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              style={{
                position: "fixed",
                top: "20px",
                right: "20px",
                zIndex: 1050,
              }}
            >
              <Toast.Body>{toastMessage}</Toast.Body>
            </Toast>
          </div>
        </>
      )}
    </div>
  );
};

export default BranchAssignment;
